// extracted by mini-css-extract-plugin
module.exports =  {"table":"table_eVkuik3R","name":"name_fAJuyJ6f","noData":"noData_KVXFHJIz"};